module.exports = __webpack_public_path__ + "static/media/michelle_grant.92a01aa1.jpeg";